import { INITIAL_CACHE_RESET_TIMESTAMP, TAQLStoreActionsType } from '@monorepo/core-data';
import { TWipPackerStore } from '@monorepo/types';
import { produce } from 'immer';
import { TWipPackerStoreActions, TWipPackerStoreActionsType } from './wip-packer.actions';

export function getWipPackerStoreInitalState(nextCacheResetTimestamp: number): TWipPackerStore {
  return {
    nextCacheResetTimestamp: nextCacheResetTimestamp,
    cartonList: [],
    failedEvents: [],
    activity: [],
    lineMap: {},
    bctxData: {
      res: [],
      status: 'INITIAL',
    },
    selectedBctx: [],
    selectedBctxHeader: [],
    currentCartons: [],
    counts: {},
    undoList: [],
  };
}

export function WipPackerStoreStateReducer(
  state: TWipPackerStore = getWipPackerStoreInitalState(INITIAL_CACHE_RESET_TIMESTAMP),
  action: TWipPackerStoreActions,
): TWipPackerStore {
  switch (action.type) {
    case TWipPackerStoreActionsType.LoadBctxDataSuccess: {
      return produce(state, (draft) => {
        draft.bctxData = {
          res: action.res,
          status: 'UPDATED',
        };
      });
    }

    case TWipPackerStoreActionsType.UpdateWipPackerStore: {
      return produce(state, (draft) => {
        draft.selectedBctx = action.state.selectedBctx;
        draft.selectedBctxHeader = action.state.selectedBctxHeader;
        draft.currentCartons = action.state.currentCartons;
        draft.cartonList = action.state.cartonList;
        draft.lineMap = action.state.lineMap;
        // draft.bctxData = action.state.bctxData;
        draft.nextCacheResetTimestamp = action.state.nextCacheResetTimestamp;
        draft.activity = action.state.activity;
        draft.failedEvents = action.state.failedEvents;
        draft.currentCartons = action.state.currentCartons;
        draft.counts = action.state.counts;
        draft.undoList = action.state.undoList;
      });
    }
    default:
      return state;
  }
}
